// import { useEffectOnce } from "usehooks-ts";
import { useContext, useEffect, useMemo, useState } from "react";

import { useDatastoreStore } from "hooks/datastores/useDatastoresStore";
import { DatastoreContext } from "contexts/datastores/datastores";

// import { DemoContext } from "contexts/demo";
// import response from "./response.json";

export const useDatabases = () => {
  const [loadMore, setloadMore] = useState(false);
  // const { isDemo } = useContext(DemoContext);
  const { instance } = useContext(DatastoreContext);
  const instanceId = useMemo(
    () => `${instance?.type}.${instance?.name}`,
    [instance]
  );

  const isLoading = useDatastoreStore((s) => s.loadingDatabases);
  const loadDatabasesFromInstance = useDatastoreStore((s) => s.loadDatabase);

  const databases = useDatastoreStore((s) =>
    instanceId ? s.databasesFromInstance[instanceId] : []
  );
  const paging = useDatastoreStore((s) =>
    instanceId ? s.databasesPagingFromInstance[instanceId] : {}
  );

  useEffect(() => {
    if (instanceId) {
      loadDatabasesFromInstance(instanceId);
    }
  }, [instanceId, loadDatabasesFromInstance, loadMore]);

  // useEffectOnce(() => {
  //   instanceId && loadDatabasesFromInstance(instanceId);
  // });

  return {
    res: databases,
    isLoading,
    error: undefined,
    paging: paging,
    setloadMore: setloadMore,
    loadMore: loadMore,
  };
};
